import { useSelector } from '@xstate5/react';

import { useEssentialMachines } from '../../EssentialMachines';

/**
 * Returns a `boolean` indicating the state of unsuccessful login.
 */
export const useHasFailedToFetchCustomerData = () => {
  const { authMachineRef } = useEssentialMachines();

  return useSelector(authMachineRef, (state) => {
    return state.matches({ session: { loggedOut: 'customer-fetch-failed' } });
  });
};
